import styled from "styled-components";
import * as ColorScheme from './ColorScheme';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - var(--dashboard-shell-top-nav-height));
  color: ${ColorScheme.dark_gray};
  padding-top: calc(var(--dashboard-shell-db-dropdown-height) + 28px);
  padding-inline: clamp(16px, 3vw, 32px);
`

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

export const InfoBubble = styled.div`
  box-sizing: border-box;
  padding: 5px;
  width: 325px;
  height: 100px;
  border: 2px solid gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
`

export const InfoBubbleTitle = styled.div`
  text-align: center;
  font-weight: bold;
  font-size: 22px;
`

export const InfoBubbleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  font-size: 18px;
  user-select: none;
  cursor: default;
`

export const ProductsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ProductsTitle = styled.div`
  text-align: center;
  font-size: ${props => props.fontSize};
  font-weight: bold;
  cursor: default;
`

export const LandingIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  max-width: 665px;
  gap: ${props => props.gap};
  flex-wrap: wrap;
`

export const LandingIconRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  user-select: none;
  &:hover {
    color: ${ColorScheme.sawatch_blue};
    .landing-icon {
      width: ${props=> props.wrapperLength};
      height: ${props=> props.wrapperLength}
    }
  }
`

export const LandingIconHoverContainer = styled.div`
  width: ${props => props.wrapperLength};
  height: ${props => props.wrapperLength};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const LandingIcon = styled.img`
  width: ${props => props.iconLength};
  height: ${props => props.iconLength};
  box-shadow: 0px 0px ${props => props.shadowSize} rgba(0, 0, 0, 0.15);
  border-radius: ${props => props.borderRadius};
`

export const LandingIconText = styled.div`
  text-align: center;
  font-size: ${props => props.fontSize};
  max-width: ${props => props.width};
`

export const Bold = styled.span`
  font-weight: bold;
`

export const LandingFooter = styled.div`
  bottom: 0;
  padding: 24px 14px;
  background-color: ${ColorScheme.white};
  text-align: center;
  font-size: 15px;
  line-height: 1.2rem;
  margin-top: auto;
`

export const Link = styled.a`
  text-decoration: none;
  color: ${ColorScheme.dark_aqua};
  &:hover {
      text-decoration: underline;
  }
`

export const UnderlineLink = styled(Link)`
  text-decoration: underline;
`

export const TriangleWrapper = styled.div`
  width: 20px;
  height: 10px;
`

export const TcoValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
`

export const CookieBannerContainer = styled.div`
  height: 150px;
  max-width: 600px;
  border: 1px solid black;
  position: fixed;
  bottom: 18px;
  left: calc(var(--dashboard-shell-sidebar-width) + 18px);
  text-align: left;
  padding: 0 15px 10px 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  row-gap: 5px;
  font-size: 14px;
  background-color: rgb(245, 245, 245);
  border: none;
  border-radius: 2px;
  z-index: 100;
  box-shadow: 0 0 15px rgba(0, 0, 0, .15);
`

export const CookieBannerAcceptBtn = styled.div`
  width: 130px;
  height: 40px;
  background-color: rgba(3, 94, 91, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  color: white;
  align-self: flex-end;
  cursor: pointer;
  font-size: 15px;
`

export const CookieBannerCloseBtn = styled.button`
  height: 20px;
  align-self: flex-end;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: rgb(85, 85, 85);
  font-size: 20px;
  padding: 0;
  margin: 0;
`